window.addEventListener("load", () => {
  const navItems = document.querySelectorAll(".sidebar-nav-item");
  const cards = document.querySelectorAll(".date-deadline-card");

  navItems.forEach((item) => {
    item.addEventListener("click", () => {
      const targetId = item.getAttribute("data-target");
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        navItems.forEach((nav) => nav.classList.remove("active"));
        item.classList.add("active");

        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  const observerOptions = {
    root: null,
    rootMargin: "-15% 0px -70% 0px",
    threshold: 0,
  };

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        const id = entry.target.getAttribute("id");
        const activeNav = document.querySelector(
          `.sidebar-nav-item[data-target="${id}"]`,
        );

        if (activeNav) {
          navItems.forEach((nav) => nav.classList.remove("active"));
          activeNav.classList.add("active");
        }
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  cards.forEach((card) => observer.observe(card));
});
